// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `chart-skeleton-component{height:100%;width:100%}.chart-skeleton-component{height:100%}`, "",{"version":3,"sources":["webpack://./src/shared/components/chart-skeleton/chart-skeleton.component.scss"],"names":[],"mappings":"AAAA,yBACI,WAAA,CACA,UAAA,CAEJ,0BACI,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
